import React from "react"
import { checkPermission } from "../../helper/functions"
import User from "../../libs/admin"
import { TYPOGRAPHY } from "./constants/theme"

// Components
import FilterBar from "./components/FilterBar"
import CustomerTable from "./components/CustomerTable"
import PaginationNew from "./components/PaginationNew"
import AddPlanModal from "./components/AddPlanModal"

// Hooks
import { useCustomerList, useAddPlanModal } from "./hooks/useCustomerList"

// Styles
import { mainContainerStyle, headerSectionStyle, headerTitleStyle, primaryButtonStyle } from "./styles/commonStyles"

function CustomerList() {
	const user = User.getCookieData()

	// Customer list logic
	const {
		search,
		setSearch,
		orderIdSearch,
		setOrderIdSearch,
		searchType,
		setSearchType,
		filterStatus,
		setFilterStatus,
		filterRecurring,
		setFilterRecurring,
		filterPlan,
		setFilterPlan,
		planCountOperator,
		setPlanCountOperator,
		planCountValue,
		setPlanCountValue,
		planList,
		customers,
		customerSchedules,
		loading,
		page,
		totalPages,
		total,
		limit,
		isPlanDropdownOpen,
		setIsPlanDropdownOpen,
		planDropdownRef,
		handleSearch,
		handlePageChange,
		handleLimitChange,
		fetchData,
	} = useCustomerList()

	// Add plan modal logic
	const {
		isAddPlanModalOpen,
		setIsAddPlanModalOpen,
		userSearchQuery,
		setUserSearchQuery,
		foundUsers,
		selectedUser,
		setSelectedUser,
		selectedPlanForUser,
		setSelectedPlanForUser,
		isSearchingUsers,
		isAddingPlan,
		hasSearched,
		searchUsers,
		handleAddPlanToUser,
		handleModalClose,
	} = useAddPlanModal()

	// Handle add plan with data refresh
	const handleAddPlan = async () => {
		const success = await handleAddPlanToUser()
		if (success) {
			fetchData() // Refresh customer data
		}
	}

	return (
		<div style={mainContainerStyle}>
			{/* Header */}
			<div style={headerSectionStyle}>
				<h2 style={headerTitleStyle}>สมาชิกหนังสือพิมพ์</h2>
				{checkPermission(user.permission, "add_enewspaper_customer_plan") && (
					<button
						onClick={() => setIsAddPlanModalOpen(true)}
						style={{
							...primaryButtonStyle,
							backgroundColor: "#22c55e",
							fontSize: TYPOGRAPHY.fontSize.sm,
							padding: "10px 20px",
						}}
					>
						+ เพิ่มแพ็คเกจ
					</button>
				)}
			</div>

			{/* Filter Bar */}
			<FilterBar
				search={search}
				setSearch={setSearch}
				orderIdSearch={orderIdSearch}
				setOrderIdSearch={setOrderIdSearch}
				searchType={searchType}
				setSearchType={setSearchType}
				filterStatus={filterStatus}
				setFilterStatus={setFilterStatus}
				filterRecurring={filterRecurring}
				setFilterRecurring={setFilterRecurring}
				filterPlan={filterPlan}
				setFilterPlan={setFilterPlan}
				planCountOperator={planCountOperator}
				setPlanCountOperator={setPlanCountOperator}
				planCountValue={planCountValue}
				setPlanCountValue={setPlanCountValue}
				planList={planList}
				isPlanDropdownOpen={isPlanDropdownOpen}
				setIsPlanDropdownOpen={setIsPlanDropdownOpen}
				planDropdownRef={planDropdownRef}
				onSearch={handleSearch}
			/>

			{/* Customer Table */}
			<CustomerTable customers={customers} customerSchedules={customerSchedules} loading={loading} page={page} limit={limit} />

			{/* Pagination */}
			<PaginationNew page={page} totalPages={totalPages} total={total} limit={limit} onPageChange={handlePageChange} onLimitChange={handleLimitChange} />

			{/* Add Plan Modal */}
			<AddPlanModal
				isOpen={isAddPlanModalOpen}
				onClose={handleModalClose}
				userSearchQuery={userSearchQuery}
				setUserSearchQuery={setUserSearchQuery}
				foundUsers={foundUsers}
				selectedUser={selectedUser}
				setSelectedUser={setSelectedUser}
				selectedPlanForUser={selectedPlanForUser}
				setSelectedPlanForUser={setSelectedPlanForUser}
				planList={planList}
				isSearchingUsers={isSearchingUsers}
				isAddingPlan={isAddingPlan}
				hasSearched={hasSearched}
				onSearchUsers={searchUsers}
				onAddPlan={handleAddPlan}
			/>
		</div>
	)
}

export default CustomerList
